// extracted by mini-css-extract-plugin
export default {"tableWrap":"send-record_tableWrap__mJ25+","title":"send-record_title__AWqUc","deletedColor":"send-record_deletedColor__yNoTf"};